import { render } from "./ScrapModule.vue?vue&type=template&id=03576768&scoped=true"
import script from "./ScrapModule.vue?vue&type=script&lang=js"
export * from "./ScrapModule.vue?vue&type=script&lang=js"

import "./ScrapModule.vue?vue&type=style&index=0&id=03576768&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03576768"

export default script